import React, { useCallback, useState, useEffect } from 'react'
import { Button, Table, message, Input, Modal } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { store } from "@root/store/index";
import { getHelpObject, setHelpConfirm } from "@root/common/service";
import './_index.scss'

interface DataType {
  key: number|string;
  confirmStatus: number|string; // 确认状态 0通过 1拒绝 2未确认 
  returnReason: string; // 退回原因
  recipientInstituteName: string;  // 受援(县)医院名称
  subjectList: string;  // 学科
  recipientProvinceName: string;  // 受援医院省份
}
function Index() {

  const columns: ColumnsType<DataType> = [
    {
      title: '确认状态',
      dataIndex: 'confirmStatus',
      key: 'confirmStatus',
      render: (_, a) => (
        <>
        {(()=>{
          if(a.confirmStatus === '0'){
            return ( <span style={{color: '#2a82e4'}}>已确认</span> )
          }else if(a.confirmStatus === '2'){
            return ( <span style={{color: '#ff8d1a'}}>待确认</span> )
          }else{
            return ( <span style={{color: '#ff5733'}}>退回修改</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '退回原因',
      dataIndex: 'returnReason',
      key: 'returnReason',
    },
    {
      title: '受援医院省份',
      dataIndex: 'recipientProvinceName',
      key: 'recipientProvinceName',
    },
    {
      title: '受援医院名称',
      dataIndex: 'recipientInstituteName',
      key: 'recipientInstituteName',
    },
    {
      title: '帮扶学科',
      dataIndex: 'subjects',
      key: 'subjects',
      render: (_, a) => (
        <>
        {(()=>{
          const arr: any = []
          if(!!a.subjectList){
            a.subjectList.split(',').forEach((e: any)=>{
              subjectIdArr.forEach((el: any)=>{
                // eslint-disable-next-line eqeqeq
                if(e==el.id){
                  arr.push(el.name)
                }
              })
            })
          }
          return arr.map((e: any,i: number)=>{
            return <span style={{marginRight: '5px', color: '#2a82e4'}} key={i}>{e}</span>
          })
        })()
        }
        </>
      ),
    },
  ];

  const [data, setData] = useState<DataType[]>();
  const [reason, setReason] = useState('');
  const [isAddVisible, setIsAddVisible] = useState(false);
  const [subjectIdArr, setSubjectIdArr] = useState<any>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [batch, setBatch] = useState<number>()


  const getAll = async()=>{
    const {data: a} = await getHelpObject(`type=0`)
    a.forEach((e: any)=>{
      e.key = e.id
    })
    setData(a)
  }
  // const getBatch = async()=>{
  //   const {data: a} = await getHospitalBatch({
  //     instituteId: store.getState().userInfo.instituteId
  //   })
  //   setBatch(a.batchNumber)
  // }

  useEffect(()=>{
    console.log(store.getState());
    setSubjectIdArr(store.getState().directionaries.subjectData)
    getAll()
    // getBatch()
  },[])

  const start = useCallback((e: string) => {
    if(e==='0'){
      const setSubmint = async()=>{
        const res = await setHelpConfirm({
          ids: selectedRowKeys,
          statusEnum: e,
          returnReason: ''
        })
        console.log(res);      
      }
      setSubmint()
    }else{
      setIsAddVisible(true)
    }
  },[selectedRowKeys])
  const addCancel = useCallback(()=>{
    setIsAddVisible(false)
  },[])
  const changeReason = useCallback((e: any)=>{
    setReason(e.target.value);    
  },[])
  const handleOk = useCallback(()=>{
    console.log(reason);
    const setSubmint = async()=>{
      const {code, msg} = await setHelpConfirm({
        ids: selectedRowKeys,
        statusEnum: '1',
        returnReason: reason
      })
      if(code === 200){
        message.success(`${msg}`);
        getAll()
      }else{
        message.error(`${msg}`);
      } 
    }
    setSubmint()
    setIsAddVisible(false)
  },[reason,selectedRowKeys])
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  // console.log('selectedRowKeys changed: ', selectedRowKeys);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div>
      <div className='midBtn'>
        <Button type="primary" onClick={()=>start('0')} disabled={!hasSelected}>确认</Button>
        <Button type="primary" onClick={()=>start('1')} disabled={!hasSelected}>退回修改</Button>
      </div>

      <div>
        <Table bordered rowSelection={rowSelection} columns={columns} dataSource={data} />
      </div>

      <Modal title="退回修改" visible={isAddVisible} onCancel={addCancel} onOk={handleOk}>
      退回原因：<Input placeholder="请输入退回原因" style={{ width: 320 }} value={reason} onChange={changeReason}/>
      </Modal>
    </div>
  )
}

export default Index